var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("BjImportFile", {
        ref: "BjImportFile",
        attrs: {
          accept: ".xls,.xlsx",
          "limit-size": 128 * 1024,
          "auto-upload": "",
        },
        on: { importFile: _vm.importFile },
      }),
      _c(
        "div",
        { staticClass: "flex-align-justify" },
        [
          _c("BjInput", {
            staticStyle: { width: "300px", margin: "20px 0" },
            attrs: { placeholder: "执行秒数" },
            model: {
              value: _vm.time,
              callback: function ($$v) {
                _vm.time = $$v
              },
              expression: "time",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex-align-justify" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirm } },
            [_vm._v("生成订单发货通知单,并解除库存锁定")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirm2 } },
            [_vm._v("手动发货并解除库存锁定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }